/**
 * Lo que el menu y el Dashboard PINTAN, sin tocar el DOM (APR-BOTONES-T1, Ares #25677).
 *
 * Vive aparte del NavBar para que un guardia lo pueda correr en node y medir lo
 * pintado, no el texto del archivo. Q #25678/#25679: el enlace Aprobaciones
 * (audience 'both') estaba en NAV_LINKS desde el PR 366, pero buildLinksHtml solo
 * pintaba el Dashboard y los grupos 'business' y 'nexo': nunca se pinto, para
 * ningun rol. Y el dueno que entra con su negocio cae en el Dashboard de la
 * tablet, que no tenia como llegar a la bandeja.
 *
 * @module presentation/components/menuDelPanel
 */

/**
 * Agrupa los enlaces ya filtrados (rol + audiencia) en el orden en que se pintan:
 * Dashboard, los demas 'both' (Aprobaciones), Operativo y Nexo Internal.
 * @returns {Array<{tipo:'enlace', enlace:object}|{tipo:'separador', etiqueta:string}>}
 */
export function gruposDelMenu(links, userAudience) {
  const dashboard = links.find(l => l.hash === '#/');
  const deTodos = links.filter(l => l.audience === 'both' && l.hash !== '#/');
  const businessLinks = links.filter(l => l.audience === 'business');
  const nexoLinks = links.filter(l => l.audience === 'nexo');
  const partes = [];

  if (dashboard) partes.push({ tipo: 'enlace', enlace: dashboard });
  // Lo que es de todos va pegado al Dashboard, antes de los grupos: un 'both'
  // no pertenece a ninguno y por eso se quedaba sin pintar.
  deTodos.forEach(l => partes.push({ tipo: 'enlace', enlace: l }));

  if (businessLinks.length > 0 && (userAudience === 'all' || userAudience === 'business')) {
    partes.push({ tipo: 'separador', etiqueta: 'Operativo' });
    businessLinks.forEach(l => partes.push({ tipo: 'enlace', enlace: l }));
  }
  if (nexoLinks.length > 0 && (userAudience === 'all' || userAudience === 'nexo')) {
    partes.push({ tipo: 'separador', etiqueta: 'Nexo Internal' });
    nexoLinks.forEach(l => partes.push({ tipo: 'enlace', enlace: l }));
  }
  return partes;
}

/**
 * La tarjeta Aprobaciones del Dashboard, con el lugar del conteo de pendientes.
 * En la tablet (renderBusinessDashboard) solo la ve el dueno (manager): el
 * colaborador (client) no decide lo que pide la caja (regla #5638).
 * @param {{ tablet: boolean, role: string, permitida: boolean }} q
 */
export function tarjetaAprobaciones({ tablet, role, permitida }) {
  if (!permitida) return '';
  if (tablet && role !== 'manager') return '';
  return '<a href="#/notificaciones" class="dash-card" data-dash-aprobaciones>'
    + '<span class="dash-icon">&#9989;</span><span class="dash-label">Aprobaciones</span>'
    + '<span class="dash-count" data-dash-aprobaciones-conteo style="white-space:pre-line;text-align:center">Lo que pide la caja</span></a>';
}

/**
 * El conteo en palabras, de contarPorAprobar: SOLO solicitudes por decidir (los
 * insumos en cero viven en la bandeja, no en este numero; Q #25698).
 * null = no se pudo saber: se deja el texto de siempre, sin inventar un cero.
 */
export function conteoEnPalabras(n, masVieja = null) {
  if (n === null || n === undefined || !Number.isFinite(n) || n < 0) return 'Lo que pide la caja';
  if (n === 0) return 'Nada por aprobar';
  // Ares #26726: la mas vieja en un segundo renglon (la tarjeta mide ~148px utiles; una frase larga se parte a la mitad). Solo si pasa de un dia: "la mas vieja, de hoy" no dice nada.
  const vieja = masVieja && Number.isFinite(masVieja.dias) && masVieja.dias > 1
    ? '\nla más vieja: ' + masVieja.dias + ' días'
    : '';
  return n + ' por aprobar' + vieja;
}
